import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './css/base.scss';
import axios from 'axios'

axios.defaults.baseURL = '/api/'

window.axios = axios

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
